<div class="flex flex-col media-cards white-bg" (click)="openDocument()">
  <div class="flex flex-row btn-font mt-12 mb-12 pl-20 pr-20 pt-12">
    <span class="name word-break-word fw-600 fs-24 h-50">{{media.name}}</span>
  </div>
  <div class="pl-24 pr-24 fw-700 fs-12 mb-12">{{ 'SERVICE.GUIDE' | transloco }}</div>
  <div class="h-80 mb-20">
    <div class="pl-24 pr-24 word-break-word description fw-400 fs-14">{{ media.description }}</div>
  </div>
  <div class="flex flex-row pl-24">
    <mat-icon svgIcon="description"></mat-icon>
    <div class="fw-500 fs-16 mb-20 ml-8">{{ 'SERVICE.READ_DOCUMENT' | transloco }}</div>
  </div>
</div>
